<div class="c-navigation">
  <maced-cascade-menubar cascadeMenubarId="Cascade Menubar" [cascadeMenubarLabel]="cascadeMenubarLabel"
    [cascadeMenuList]="cascadeMenuList" [hasAriaControls]="false" [backUrl]="backUrl" [closeUrl]="closeUrl" [backQueryParams]="backQueryParams"
    [closeQueryParams]="closeQueryParams" [cascadeLeftIconHidden]="true">
  </maced-cascade-menubar>
</div>